import request from "@/utils/request";

//产品轮播
export function family(seriesIdOrParams) {
  let data = {};
  if (seriesIdOrParams && typeof seriesIdOrParams === "object") {
    data = { ...seriesIdOrParams };
  } else if (seriesIdOrParams) {
    data = { seriesId: seriesIdOrParams };
  }

  return request({
    url: `/api/business/family/getList`,
    method: "post",
    data,
  });
}
//产品功能点
export function getListByFamilyId(id) {
  return request({
    url: `/api/business/familyFun/getListByFamilyId/${id}`,
    method: "get",
  });
}
//竞品对比
export function familyComparison(id) {
  return request({
    url: `/api/business/familyComparison/getList/${id}`,
    method: "post",
  });
}
//系统配置
export function productComputerConfig(productId) {
  return request({
    url: `/api/business/familySystemConf/getList/${productId}`,
    method: "post",
  });
}
//常见问题
export function commonQuestion(productId) {
  return request({
    url: `/api/business/commonQuestion/getList/${productId}`,
    method: "post",
  });
}
//意见反馈
export function BaseFeedback(id) {
  return request({
    url: `/api/business/BaseFeedback`,
    method: "post",
  });
}
//子项
export function industryAppItem(refId) {
  return request({
    url: `/api/business/industryAppItem/getList?refId=${refId}`,
    method: "post",
  });
}
//系列下拉
export function Selector(enabledMark = true) {
  return request({
    url: `/api/system/DictionaryData/804629366070867141/Data/Selector?enabledMark=${enabledMark}`,
    method: "GET",
  });
}

//家族分类下拉
export function FamilyCodeSelector(enabledMark = true) {
  return request({
    url: `/api/system/DictionaryData/783958266211225925/Data/Selector?enabledMark=${enabledMark}`,
    method: "GET",
  });
}
//订阅
export function subscribeGuide() {
  return request({
    url: `/api/business/subscribeGuide/getList`,
    method: "POST",
  });
}
//订阅详情
export function subscribeGuideItem(id) {
  return request({
    url: `/api/business/subscribeGuideItem/getListBySubId/${id}`,
    method: "POST",
  });
}
//行业应用详情
export function industryApplications(id) {
  return request({
    url: `/api/business/industryApplications/getInfo/${id}`,
    method: "get",
  });
}


